// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__36AT4","additionalInfo":"AgreementModal_additionalInfo__9PUIJ"};